import { Placeholder } from 'react-bootstrap';

const TemplatePreviewSkeleton = () => {
	return (
		<div className="slide-img-previewbox" style={{ width: '100%', height: window.innerHeight }}>
			<Placeholder as="div" className="slide-img-preview h-100 p-4 p-md-5" xs={12}>
				<Placeholder as="p" animation="glow">
					<Placeholder
						className="mb-2 rounded-circle"
						style={{ height: '100px', width: '100px' }}
						xs={6}
					/>
				</Placeholder>
				<Placeholder as="p" animation="glow">
					<Placeholder className="rounded" style={{ height: '25px' }} xs={6} lg={4} />
				</Placeholder>
				<Placeholder as="p" animation="glow">
					<Placeholder className="mb-5 rounded" xs={4} lg={2} />
				</Placeholder>
				<Placeholder as="p" animation="glow">
					<Placeholder className="mb-3 rounded" xs={12} />
					<Placeholder className="mb-3 rounded" xs={12} />
					<Placeholder className="mb-3 rounded" xs={12} />
					<Placeholder className="mb-3 rounded" xs={12} />
					<Placeholder className="mb-3 rounded" xs={12} />
					<Placeholder className="mb-3 rounded" xs={5} />
				</Placeholder>
			</Placeholder>
		</div>
	);
};

export default TemplatePreviewSkeleton;
